@if (loading) {
  <div>
    <h3 class="panel-title">Verifying your email address</h3>
    <div class="margin-top"><i class="fa-solid fa-spinner fa-spin"></i> Please wait while we verify your email...</div>
  </div>
}
@if (verified) {
  <div>
    <h3 class="panel-title">Thanks for verifying your email address</h3>
    @if (accounts.length === 1) {
      <div class="margin-top">
        Now that we know who you really are, you can
        <a routerLink="{{ usersLink }}">invite your friends and colleagues</a> to join you.
      </div>
    } @else {
      <div class="margin-top">Click <a routerLink="/">here</a> to continue to your account.</div>
    }
  </div>
}
@if (verificationError) {
  <div>
    <h3 class="panel-title">Hmmm...</h3>
    <div class="margin-top">
      The verification token in the link you've visited has expired or is invalid. Please send a new verification email
      from the Users settings panel in the {{ uiService.productName }} console.
    </div>
  </div>
}
@if (!validContext) {
  <div>
    <h3 class="panel-title">Hmmm...</h3>
    <div class="margin-top">
      The link you've visited is missing the required parameters to verify your email address. Do you mind checking the
      link and trying again?
    </div>
  </div>
}
